import React, { useEffect } from 'react';
import { Card } from 'antd';
import LoanRepaymentList from '../../components/LoanRepayment/LoanRepaymentList';
import { useLoanRepayment } from '../../store/loanRepaymentContext';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const LoanRepaymentListPage: React.FC = () => {
    const { fetchLoanRepayments } = useLoanRepayment();
    const navigate = useNavigate();

    useEffect(() => {
        fetchLoanRepayments();
    }, []);

    const handleEdit = (repayment: any) => {
        navigate(`/loan-repayments/form/${repayment.id || repayment._id}`);
    };

    return (
        <div style={{ padding: 16 }}>
            <Card title={t('loanRepaymentList')} variant="outlined">
                <LoanRepaymentList onEdit={handleEdit} />
            </Card>
        </div>
    );
};

export default LoanRepaymentListPage;
